import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("ButtonGroup", {
  root: (maxWidth) => css`
    max-width: ${maxWidth};
  `,
  inner: (justify, columnSize) => css`
    display: grid;
    gap: var(--zds-space-12, 10px) var(--zds-space-20, 20px);
    justify-content: ${justify};
    grid-template-columns: repeat(auto-fit, ${columnSize});
  `
});
const ButtonGroup = ({ children, columnSize = "minmax(0, 1fr)", justify = "start", maxWidth = "initial" }) => {
  return jsx(
    "div",
    { css: Styles.root(maxWidth), "data-zds": true },
    jsx("div", { css: Styles.inner(justify, columnSize), "data-zds": true }, children)
  );
};

export { ButtonGroup };
//# sourceMappingURL=ButtonGroup.es.js.map
